module.exports = __webpack_public_path__ + "img/fail.e96ff126.svg";